import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Select,
  Modal,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";
import { FileIcon } from "@shopify/polaris-icons";
import Select2 from "react-select";
import { MultiSelect } from "primereact/multiselect";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/saga-blue/theme.css";
import { PlusIcon } from "@shopify/polaris-icons";
import { EDITOR_CONFIG } from "../../../constants";
import JoditEditor from "jodit-react";
const AddEditSubmembership = (props) => {
  const navigate = useNavigate();
  const slugify = (str) =>
    str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/[\s_-]+/g, "-")
      .replace(/^-+|-+$/g, "");
  const { id, submembershipId } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const imageKey = useRef("");
  const logoKey = useRef("");
  const videoKey = useRef("");
  const editor = useRef(null);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [item, setItem] = useState({
    title: "",
    gender: "",
    is_active: true,
    description: "",
    price: "",
    expiry: "",
    expiry_frequency: "",
    max_bookings: "",
    classes:
      String(localStorage.getItem("is_custom")) === "1"
        ? [
            {
              class: [],
              // max_bookings: "",
              free_bookings: "",
              discounted_price: "",
              limited_or_unlimited: "limited",
              group_id: "",
              // frequency: "",
            },
          ]
        : [],
    note: "",
    elements: [],
  });
  const handleChangeMaxBookings = (newValue) => {
    setItem({ ...item, max_bookings: newValue });
    // setTitleError("");
  };
  const handleChangeTitle = (newValue) => {
    setItem({ ...item, title: newValue });
    setTitleError("");
  };
  const [titleError, setTitleError] = useState("");
  const handleChangeNote = (newValue) => {
    setItem({ ...item, note: newValue });
    setNoteError("");
  };
  const [freeBookingsCountError, setNoteError] = useState("");
  const handleChangeExpiry = (newValue) => {
    setItem({ ...item, expiry: newValue });
    setExpiryError("");
  };
  const [expiryError, setExpiryError] = useState("");
  const handleChangeExpiryFrequency = (newValue) => {
    setItem({ ...item, expiry_frequency: newValue });
    setExpiryFrequencyError("");
  };
  const [expiryFrequencyError, setExpiryFrequencyError] = useState("");
  const handleChangePrice = (newValue) => {
    setItem({ ...item, price: newValue });
    setPriceError("");
  };
  const [priceError, setPriceError] = useState("");
  const handleChangeDescription = (newValue) => {
    setItem({ ...item, description: newValue });
  };
  const handleChangeGender = (newValue) => {
    setItem({ ...item, gender: newValue });
    setGenderError("");
  };
  const [genderError, setGenderError] = useState("");
  const handleChangeActive = (newValue) => {
    setItem({ ...item, is_active: newValue });
  };
  const [files, setFiles] = useState([]);
  const handleDropZone = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiles((files) => [...files, ...acceptedFiles]),
    []
  );
  const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
  const fileUpload = !files.length && (
    <DropZone.FileUpload actionHint={"Accepts jpegs and pngs"} />
  );
  const uploadedFiles = files.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(files[files.length - 1].type)
              ? window.URL.createObjectURL(files[files.length - 1])
              : NoteIcon
          }
        />
        <div>
          {files[files.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {files[files.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const sendImage = (files) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity", "news");
    form_data.append("image", files[files.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data;
        setIsImageUploading(false);
        setItem({
          ...item,
          image:
            validImageTypes.indexOf(files[files.length - 1].type) > 0
              ? window.URL.createObjectURL(files[files.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
        setImageError("");
      })
      .catch(function (error) {});
  };

  const [filesVideo, setFilesVideo] = useState([]);
  const handleDropZoneVideo = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesVideo((filesVideo) => [...filesVideo, ...acceptedFiles]),
    []
  );
  const fileUploadVideo = !filesVideo.length && (
    <DropZone.FileUpload actionHint={"Accepts mp4"} />
  );
  const uploadedFilesVideo = filesVideo.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(filesVideo[filesVideo.length - 1].type)
              ? window.URL.createObjectURL(filesVideo[filesVideo.length - 1])
              : NoteIcon
          }
        />
        <div>
          {filesVideo[filesVideo.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {filesVideo[filesVideo.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const sendVideo = (filesVideo) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity", "intro_content");
    form_data.append("video", filesVideo[filesVideo.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        videoKey.current = result.data.data;
        setIsImageUploading(false);
        setItem({
          ...item,
          video:
            validImageTypes.indexOf(filesVideo[filesVideo.length - 1].type) > 0
              ? window.URL.createObjectURL(filesVideo[filesVideo.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };

  const [filesLogo, setFilesLogo] = useState([]);
  const handleDropZoneLogo = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesLogo((filesLogo) => [...filesLogo, ...acceptedFiles]),
    []
  );
  const fileUploadLogo = !filesLogo.length && (
    <DropZone.FileUpload
      actionHint={
        "Accepts svgs, jpegs and pngs (Required size: 200x200 pixels)"
      }
    />
  );
  const uploadedFilesLogo = filesLogo.length > 0 && (
    <div style={{ padding: "0" }}>
      {filesLogo.map((file, index) => (
        <div key={index} className="rowDiv">
          <Thumbnail
            size="small"
            alt={file.title}
            source={
              validImageTypes.includes(file.type)
                ? window.URL.createObjectURL(file)
                : NoteIcon
            }
          />
          <div>
            {file.title}{" "}
            <Text variant="bodySm" as="p">
              {file.size} bytes
            </Text>
          </div>
        </div>
      ))}
    </div>
  );
  const sendImageLogo = (filesLogo) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity", "intro_content");
    form_data.append("image", filesLogo[filesLogo.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        logoKey.current = result.data.data;
        setIsImageUploading(false);
        setItem({
          ...item,
          logo:
            validImageTypes.indexOf(filesLogo[filesLogo.length - 1].type) > 0
              ? window.URL.createObjectURL(filesLogo[filesLogo.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };
  const [imageError, setImageError] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  const [optionsClasses, setOptionsClasses] = useState([]);
  const handleChangeClass = (index, field, value) => {
    const updatedClasses = [...item.classes];
    updatedClasses[index][field] = value;
    setItem({ ...item, classes: updatedClasses });
  };
  const handleAddClass = () => {
    setItem({
      ...item,
      classes: [
        ...item.classes,
        {
          class: [],
          // max_bookings: "",
          free_bookings: "",
          discounted_price: "",
          limited_or_unlimited: "limited",
          // frequency: "",
        },
      ],
    });
  };
  const handleRemoveClass = (index) => {
    const updatedClasses = [...item.classes];
    updatedClasses.splice(index, 1);
    setItem({ ...item, classes: updatedClasses });
  };
  const [classError, setClassError] = useState("");
  const [optionsElements, setOptionsElements] = useState([]);
  const handleSelectChangeElement = (newValue) => {
    setItem({ ...item, element: newValue });
    setTs(+new Date());
  };
  const [ts, setTs] = useState("");

  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    axios
      .get(`/classes-list-by-element?element_ids=${item.elements.join(",")}`)
      .then((result) => {
        console.log(result.data.data);
        String(localStorage.getItem("is_custom")) === "0"
          ? setItem({
              ...item,
              classes: result.data.data.map((item) => String(item.id)),
            })
          : setItem({
              ...item,
              classes: result.data.data.map((i) => ({
                class: [{ label: i.name, value: String(i.id) }],
                free_bookings: "",
                discounted_price: "",
                limited_or_unlimited: "unlimited",
              })),
            });
      })
      .catch((err) => console.log(err));
  }, [ts]);
  async function fetchData() {
    let responseItem = "";
    let responseClasses = [];
    let responseElements = [];

    try {
      responseClasses = await axios.get(`/classes-list`);
      setOptionsClasses(
        responseClasses.data.data.map((item, index) => {
          return {
            label: item.name,
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
    try {
      responseElements = await axios.get(`/elements`);
      setOptionsElements(
        responseElements.data.data.data.map((item, index) => {
          return {
            label: item.title,
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }

    if (props.type === "edit") {
      console.log("okkkk");
      try {
        responseItem = await axios.get(
          `/memberships/${id}/submemberships/${submembershipId}`
        );
        setItem({
          max_bookings: responseItem?.data?.data?.max_bookings
            ? String(responseItem.data.data.max_bookings)
            : "",
          title: responseItem?.data?.data?.name
            ? responseItem.data.data.name
            : "",
          description: responseItem?.data?.data?.description
            ? responseItem.data.data.description
            : "",
          expiry: responseItem?.data?.data?.expiry_duration
            ? String(responseItem.data.data.expiry_duration)
            : "",
          expiry_frequency: responseItem?.data?.data?.expiry_frequency
            ? responseItem.data.data.expiry_frequency
            : "",
          note:
            responseItem?.data?.data?.note !== null
              ? String(responseItem.data.data.note)
              : "",
          price:
            responseItem?.data?.data?.price !== null
              ? String(responseItem.data.data.price)
              : "",
          // classes:
          //   responseItem?.data?.data?.classes &&
          //   responseItem?.data?.data?.classes.length
          //     ? responseItem?.data?.data?.classes.map((item) => String(item.id))
          //     : "",
          elements:
            responseItem?.data?.data?.elements &&
            responseItem?.data?.data?.elements.length
              ? responseItem?.data?.data?.elements.map((item) =>
                  String(item.id)
                )
              : [],
          is_active: responseItem?.data?.data?.is_active ? true : false,
          classes:
            String(localStorage.getItem("is_custom")) === "1"
              ? responseItem?.data?.data?.classes &&
                responseItem?.data?.data?.classes.length
                ? responseItem?.data?.data?.custom_class_groups.map((group) => {
                    return {
                      class: group.classes.map((cls) => ({
                        label: cls.name,
                        value: String(cls.id),
                      })),
                      free_bookings: String(
                        group.free_bookings_per_month ?? ""
                      ),
                      discounted_price: String(group.discounted_price ?? ""),
                      group_id: group.group_id,
                      limited_or_unlimited:
                        group.free_bookings_per_month !== null
                          ? "limited"
                          : "unlimited", // adjust if you have a flag for this
                    };
                  })
                : // responseItem?.data?.data?.classes.map((item) => ({
                  //     class: {
                  //       label: item.name,
                  //       value: String(item.id),
                  //     },
                  //     free_bookings: item.pivot?.free_bookings_per_month,
                  //     limited_or_unlimited:
                  //       item.pivot?.free_bookings_per_month !== "" &&
                  //       item.pivot?.free_bookings_per_month !== null
                  //         ? "limited"
                  //         : "unlimited",
                  //     discounted_price: item.pivot?.discounted_price,
                  //   }))
                  []
              : responseItem?.data?.data?.classes &&
                responseItem?.data?.data?.classes.length
              ? responseItem?.data?.data?.classes.map((item) => String(item.id))
              : [],
        });
      } catch (error) {
        console.log(error);
      }
    }

    setIsSaving(false);
  }
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/memberships/${id}/submemberships/${submembershipId}`)
      .then((result) => {
        navigate(`/admin/memberships/${id}/submemberships`);
      })
      .catch((err) => console.log(err));
  };
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Option`}
      backAction={{
        onAction: () => navigate(`/admin/memberships/${id}/submemberships`),
      }}
      // fullWidth
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          <FormLayout.Group>
            <TextField
              value={item.title}
              onChange={handleChangeTitle}
              label="Name"
              error={titleError}
            />
            <TextField
              value={item.price}
              onChange={handleChangePrice}
              label="Price"
              error={priceError}
              type="number"
            />
          </FormLayout.Group>

          <FormLayout.Group>
            <Select
              label="Expiry Frequency"
              options={[
                { label: "Days", value: "days" },
                { label: "Weeks", value: "weeks" },
                { label: "Months", value: "months" },
                { label: "Years", value: "years" },
              ]}
              onChange={handleChangeExpiryFrequency}
              value={item.expiry_frequency}
              placeholder="Please select"
              error={expiryFrequencyError}
            />
            <TextField
              value={item.expiry}
              onChange={handleChangeExpiry}
              label="Expiry Duration"
              error={expiryError}
              type="number"
            />
          </FormLayout.Group>
          <TextField
            value={item.max_bookings}
            onChange={handleChangeMaxBookings}
            label="Bookings Cap"
            // error={expiryError}
            type="number"
            placeholder="Unlimited"
          />
          <Text>Note</Text>
          <JoditEditor
            value={item.note}
            config={EDITOR_CONFIG}
            onBlur={handleChangeNote}
          />

          {/* <
          <TextField
            value={item.note}
            onChange={handleChangeNote}
            label="Note"
            error={freeBookingsCountError}
          />
          <TextField
            value={item.description}
            onChange={handleChangeDescription}
            label="Description"
          />
          <Text>Elements</Text>
          <MultiSelect
            value={item.elements}
            options={optionsElements}
            onChange={(e) => {
              console.log(e.value);
              setItem({ ...item, elements: e.value });
              setTs(+new Date());
            }}
            filter={true}
            placeholder="Please select"
            style={{ width: "100%" }}
            selectAllLabel="Select All"
            display="chip"
          />
          <Text>Classes</Text>
          {/* <Select2
            options={optionsClasses}
            onChange={handleSelectChangeClass}
            value={item.classes}
            placeholder="Please select"
            styles={{
              // Fixes the overlapping problem of the compont
              menu: (provided) => ({ ...provided, zIndex: 9999 }),
            }}
            isMulti
          /> */}

          <Text>Elements</Text>
          <MultiSelect
            value={item.elements}
            options={optionsElements}
            onChange={(e) => {
              console.log(e.value);
              setItem({ ...item, elements: e.value });
              setTs(+new Date());
            }}
            filter={true}
            placeholder="Please select"
            style={{ width: "100%" }}
            selectAllLabel="Select All"
            display="chip"
          />

          {String(localStorage.getItem("is_custom")) === "0" ? (
            <FormLayout>
              <Text>Classes</Text>
              <MultiSelect
                value={item.classes}
                options={optionsClasses}
                onChange={(e) => {
                  console.log(e.value);
                  setItem({ ...item, classes: e.value });
                }}
                filter={true}
                placeholder="Please select"
                style={{ width: "100%" }}
                selectAllLabel="Select All"
                display="chip"
              />

              <InlineError message={classError} />
            </FormLayout>
          ) : (
            <FormLayout>
              <Text>Classes</Text>
              <table style={{ borderCollapse: "collapse", width: "100%" }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: "left", padding: "8px" }}>Class</th>

                    <th style={{ textAlign: "left", padding: "8px" }}>
                      Limited/Unlimited
                    </th>
                    <th style={{ textAlign: "left", padding: "8px" }}>
                      Free bookings per month
                    </th>

                    <th style={{ textAlign: "left", padding: "8px" }}>
                      Discounted price
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {item.classes.map((element, index) => (
                    <tr key={index}>
                      <td style={{ padding: "8px", width: "250px" }}>
                        <Select2
                          options={optionsClasses}
                          onChange={(value) =>
                            handleChangeClass(index, "class", value)
                          }
                          value={element.class}
                          placeholder="Please select"
                          styles={{
                            container: (provided) => ({
                              ...provided,
                              width: "250px",
                            }),
                            menu: (provided) => ({
                              ...provided,
                              maxHeight: "150px",
                              overflowY: "auto",
                            }),
                            menuList: (provided) => ({
                              ...provided,
                              maxHeight: "150px",
                            }),
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          isMulti
                        />
                      </td>

                      <td style={{ padding: "8px" }}>
                        <Select
                          options={[
                            { label: "Limited", value: "limited" },
                            { label: "Unlimited", value: "unlimited" },
                          ]}
                          onChange={(value) =>
                            handleChangeClass(
                              index,
                              "limited_or_unlimited",
                              value
                            )
                          }
                          value={element.limited_or_unlimited}
                          placeholder="Please select"
                          error={genderError}
                        />
                      </td>

                      <td style={{ padding: "8px" }}>
                        <TextField
                          type="number"
                          value={element.free_bookings}
                          onChange={(value) =>
                            handleChangeClass(index, "free_bookings", value)
                          }
                          disabled={
                            element?.limited_or_unlimited === "unlimited"
                          }
                        />
                      </td>

                      <td style={{ padding: "8px" }}>
                        <TextField
                          type="number"
                          value={element.discounted_price}
                          onChange={(value) =>
                            handleChangeClass(index, "discounted_price", value)
                          }
                          disabled={
                            element?.limited_or_unlimited === "unlimited"
                          }
                        />
                      </td>
                      <td>
                        <div style={{ marginLeft: "1rem" }}>
                          <Button
                            onClick={() => handleRemoveClass(index)}
                            variant="primary"
                            tone="critical"
                          >
                            Remove
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <InlineError message={classError} />
              <Button
                fullWidth
                variant="primary"
                onClick={handleAddClass}
                icon={PlusIcon}
              >
                Add Class
              </Button>
            </FormLayout>
          )}
          <Button onClick={() => setItem({ ...item, classes: [] })}>
            Clear all classes
          </Button>
          {/* <div style={{ height: "200px" }}></div> */}
          {/* <Select
            label="Gender"
            options={[
              { label: "Male", value: "male" },
              { label: "Female", value: "female" },
              { label: "Mixed", value: "mixed" },
            ]}
            onChange={handleChangeGender}
            value={item.gender}
            placeholder="Please select"
            error={genderError}
          /> */}

          <Checkbox
            label="Is active"
            checked={item.is_active}
            onChange={handleChangeActive}
          />
          <div style={{ height: "200px" }}></div>
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => setActiveDelete(true)}
            >
              Delete
            </Button>
          )
        }
      />
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Item"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <Text>
            <p>Are you sure you want to delete this item?</p>
          </Text>
        </Modal.Section>
      </Modal>
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    console.log(item.classes);
    if (
      !item.title ||
      !item.expiry ||
      // item.note === "" ||
      !item.price ||
      !item.classes.length ||
      !item.expiry_frequency ||
      item.classes.some(
        (item) =>
          item.limited_or_unlimited === "limited" &&
          (item.free_bookings === "" || item.discounted_price === "")
      )
    ) {
      !item.title && setTitleError("This field is required");
      !item.expiry && setExpiryError("This field is required");
      // item.note === "" &&
      //   setNoteError("This field is required");
      !item.price && setPriceError("This field is required");
      !item.classes.length && setClassError("Please select classes");
      !item.expiry_frequency &&
        setExpiryFrequencyError("Please select an option");
      item.classes.some(
        (item) =>
          item.limited_or_unlimited === "limited" &&
          (item.free_bookings === "" || item.discounted_price === "")
      ) &&
        setClassError(
          "Please fill in both free bookings and discounted price fields for all limited entries"
        );
    } else {
      console.log("tessst=", item.classes);
      setIsSaving(true);
      const form_data = new FormData();
      form_data.append("name", item.title);
      form_data.append("price", item.price);
      form_data.append("description", item.description);
      form_data.append("note", item.note);
      form_data.append("expiry_duration", item.expiry);
      form_data.append("expiry_frequency", item.expiry_frequency);
      form_data.append("max_bookings", item.max_bookings);
      item.elements.length &&
        item.elements.forEach((selected, index) =>
          form_data.append(`element_ids[${index}]`, selected)
        );
      // item.classes.forEach((selected, index) =>
      //   form_data.append(`classes[${index}]`, selected)
      // );
      form_data.append("is_active", item.is_active ? 1 : 0);
      // item.element !== "" && form_data.append("element_id", item.element);

      props.type === "edit" && form_data.append("_method", "PATCH");
      String(localStorage.getItem("is_custom")) === "0" &&
        item.classes.forEach((selected, index) =>
          form_data.append(`classes[${index}]`, selected)
        );

      console.log("test=", item.classes);
      String(localStorage.getItem("is_custom")) === "1" &&
        item.classes.forEach((selected, index) => {
          form_data.append(
            `custom_class_groups[${index}][free_bookings_per_month]`,
            selected?.limited_or_unlimited === "limited"
              ? selected.free_bookings
              : ""
          );
          form_data.append(
            `custom_class_groups[${index}][discounted_price]`,
            selected?.limited_or_unlimited === "limited"
              ? selected.discounted_price
              : ""
          );

          selected?.group_id !== "" &&
            selected?.group_id !== undefined &&
            form_data.append(
              `custom_class_groups[${index}][group_id]`,
              selected?.group_id
            );
          // form_data.append(
          //   `custom_class_groups[${index}][ids]`,
          //   selected.class.value
          // );

          selected.class.forEach((classItem, classIndex) => {
            form_data.append(
              `custom_class_groups[${index}][ids][${classIndex}]`,
              classItem.value
            );
          });
        });
      props.type === "add"
        ? axios
            .post(`/memberships/${id}/submemberships`, form_data)
            .then((result) => {
              navigate(`/admin/memberships/${id}/submemberships`);
            })
            .catch((err) => console.log(err))
        : axios
            .post(
              `/memberships/${id}/submemberships/${submembershipId}`,
              form_data
            )
            .then((result) => {
              toggleActive();
              setIsSaving(false);
            })
            .catch((err) => console.log(err));
    }
  }
};

export default AddEditSubmembership;
